/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin'],
  staff: ['admin', 'staff'],
  provider: ['admin', 'staff', 'provider'],
  user: ['admin', 'staff', 'provider', 'user'],
  onlyUser: ['user'],
  onlyProvider: ['provider'],
  onlyGuest: [],
};

export default authRoles;
